<template>
  <b-modal
    :title="file.categoria
      ? `Referencias Expediente ${file.categoria}-${file.numeroExt}`
      : `Referencias Expediente ${file.numero}`"
    v-model="showModal"
    hide-footer
    centered
    size="lg"
  >
    <div>
      <div class="row mb-3">
        <div class="col-md-12">
          <div class="py-2 box-activities">
            <vs-table
              class="wrap-table"
              stripe
              :data="(references || [])"
              noDataText="No hay referencias aun"
            >
              <template slot="header">
              </template>
              <template slot="thead">
                <vs-th>
                  Tipo Doc.
                </vs-th>
                <vs-th>
                  Número / Folio
                </vs-th>
                <vs-th v-if="showDate">
                  Fecha
                </vs-th>
                <vs-th>
                  Ver referencia
                </vs-th>
              </template>
              <template>
                <tbody>
                <vs-tr
                  v-for="(reference, index) in referencesByType"
                  :key="index"
                >
                  <vs-td v-if="!isConvention">
                    <span v-if="reference.febosId">
                      {{ findTypeDocument(reference.tipoCodigo) }}
                    </span>
                    <span v-if="!reference.febosId">
                      {{ findLabelDocument(reference.tipoCodigo) }}
                    </span>
                  </vs-td>
                  <vs-td v-if="isConvention">
                    <div v-if="reference.type === 'referenciadosTipoDnt'">
                      Documento
                    </div>
                    <div v-else>
                      {{ findTypeDocument(reference.tipoCodigo) }}
                    </div>
                  </vs-td>
                  <vs-td>
                    {{ reference.folioReferencia }}
                  </vs-td>
                  <vs-td v-if="showDate">
                    {{ reference.fechaEmision | dateFormat }}
                  </vs-td>
                  <vs-td>
                    <vs-icon
                      v-if="reference.febosId"
                      size="22px"
                      class="ml-5 pl-5 cursor-pointer"
                      icon="search"
                      @click="goToReference(reference.tipoCodigo, reference.febosId)"
                    />
                  </vs-td>
                </vs-tr>
                </tbody>
              </template>
            </vs-table>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import FindTypeDocumentMixin from '@/febos/chile/dnt/mixins/FindTypeDocumentMixin';
import configReferences from '@/febos/global/utils/configurationReferences';
import FindLabelDocumentMixin from '@/febos/chile/dnt/mixins/FindLabelDocumentMixin';

export default {
  name: 'PopUpReferencesFile',
  mixins: [FindTypeDocumentMixin, FindLabelDocumentMixin],
  props: {
    file: {
      type: [Object]
    }
  },
  data() {
    return {
      config: configReferences
    };
  },
  computed: {
    ...mapGetters('List', ['allDocumentsState']),
    ...mapGetters('Dnts', ['references', 'referencesByType']),
    ...mapGetters('Modals', ['modalName']),
    ...mapGetters('Empresas', ['company']),
    showDate() {
      const anyRefWithDate = this.references.some((r) => r.fechaEmision);
      return anyRefWithDate;
    },
    showModal: {
      get() {
        return this.modalName === 'references';
      },
      set() {
        this.closeModal();
      }
    },
    isConvention() {
      return this.company.iut === '60100003-2';
    },
    isMop() {
      return this.company.iut === '61202000-0';
    }
  },
  methods: {
    ...mapActions('Modals', [
      'closeModal'
    ]),
    findLabel(document) {
      return this.allDocumentsState.list
        .find((option) => option.value === document) || {};
    },
    goToReference(type, id) {
      const configReference = this.config[type];
      console.log(configReference);
      console.log(id);
      const route = this.$router.resolve({
        name: configReference.name,
        params: { view: configReference.view },
        query: { filters: `${configReference.query}${id}` }
      });
      window.open(route.href, '_blank');
    }
  }
};
</script>
<style>

.box-activities {
  height: 260px;
  overflow-y: scroll;
}

.m-top-20 {
  margin-top: 20px;
}
.title-activity {
  color: #671e85;
}
.chip-custom {
  font-size: 12px;
  margin-top: 10px;
  color: #ffb300;
  background: #fff5df;
  border-radius: 10px;
  padding: 4px 8px;
}
</style>
